// extracted by mini-css-extract-plugin
export var container = "_j4-0";
export var content = "_j4-3";
export var customerTitle = "_j4-4";
export var empty = "_j4-5";
export var gray = "_j4-6";
export var header = "_j4-7";
export var info = "_j4-8";
export var loading = "_j4-2";
export var loadingCard = "_j4-9";
export var oneLine = "_j4-a";
export var personName = "_j4-e";
export var pillContainer = "_j4-b";
export var selected = "_j4-1";
export var text = "_j4-c";
export var twoLines = "_j4-d";
export var unread = "_j4-f";
export var unreadIndicator = "_j4-g";